import type React from "react";
import { useEffect, useState } from "react";
import type { Product } from "@qbanq/shared";
import { api } from "../api/client";

export function ProductsPage() {
  const [products, setProducts] = useState<Product[]>([]);
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState<string | null>(null);

  function load() {
    void api.get<Product[]>("/api/products").then(setProducts);
  }
  useEffect(load, []);

  async function create(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      await api.post("/api/products", { name, slug, description });
      setName("");
      setSlug("");
      setDescription("");
      load();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed");
    }
  }

  return (
    <div>
      <h2>Products</h2>
      <p className="muted">Products are the primary routing unit. Each can have its own channels, prompt, knowledge, and escalation rules.</p>

      <div className="card">
        <h3>New product</h3>
        <form onSubmit={create}>
          <div className="row">
            <div className="field" style={{ flex: 1 }}>
              <label>Name</label>
              <input value={name} onChange={(e) => setName(e.target.value)} />
            </div>
            <div className="field" style={{ flex: 1 }}>
              <label>Slug</label>
              <input value={slug} onChange={(e) => setSlug(e.target.value)} placeholder="acme-pro" />
            </div>
          </div>
          <div className="field">
            <label>Description</label>
            <input value={description} onChange={(e) => setDescription(e.target.value)} />
          </div>
          {error && <p className="error">{error}</p>}
          <button className="btn" type="submit">Create product</button>
        </form>
      </div>

      <div className="card">
        <table>
          <thead>
            <tr><th>Name</th><th>Slug</th><th>Active</th><th>Agent id</th></tr>
          </thead>
          <tbody>
            {products.map((p) => (
              <tr key={p.id}>
                <td>{p.name}</td>
                <td className="muted">{p.slug}</td>
                <td>{p.active ? "yes" : "no"}</td>
                <td className="muted">{p.agent_id ?? "default"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
